import { Component } from "react";
import { get } from "../config/api";
import { INTERCOM_APP_ID, SERVER_URL } from "../config/app.config";

const IntercomInitState = {
	IDLE: "IDLE",
	LOADING: "LOADING",
	ERRORED: "ERRORED",
	INITIALISED: "INITIALISED",
};

var intercomServiceState = IntercomInitState.IDLE;

const FallBackErrorMessage = "Something went Wrong!";

class IntercomService extends Component {
	static async getUserHash() {
		const url = SERVER_URL + "/v1/admin/intercom/hash";
		const { data, error } = await get({ url });
		if (data) {
			return data.userHash;
		}
		if (error) {
			throw new Error(error);
		}
	}

	static async initialize(user_id) {
		if (intercomServiceState === IntercomInitState.INITIALISED) {
			return { success: true };
		}

		if (intercomServiceState === IntercomInitState.LOADING) {
			return { error: "Intercom is already initialising" };
		}

		intercomServiceState = IntercomInitState.LOADING;

		let user_hash = "";

		if (!user_id) {
			intercomServiceState = IntercomInitState.ERRORED;
			return { error: "Could not find valid user_id" };
		}

		try {
			user_hash = await this.getUserHash();
		} catch (error) {
			console.log(error);
			intercomServiceState = IntercomInitState.ERRORED;
			return { error };
		}

		try {
			window.Intercom("boot", {
				user_id,
				app_id: INTERCOM_APP_ID,
				user_hash,
			});

			console.log("Intercom Initialised");
		} catch (error) {
			//Throw Error Event?
			console.log("Could not boot intercom due to - " + error.message);
			intercomServiceState = IntercomInitState.ERRORED;
			return { error };
		}

		intercomServiceState = IntercomInitState.INITIALISED;
		return { success: true };
	}

	static openIntercomHelpDesk() {
		if (intercomServiceState === IntercomInitState.LOADING) {
			return { error: "Intercom is still initialising" };
		}

		if (intercomServiceState !== IntercomInitState.INITIALISED) {
			return { error: "Intercom has not been initialized" };
		}
		try {
			window.Intercom("show");
		} catch (error) {
			return { error: error?.message || FallBackErrorMessage };
		}
		return { success: true };
	}
}

export default IntercomService;
